package co.maytes.standupbot.dashboard.features.runslist

import co.maytes.standupbot.dashboard.components.motion.ViewPhase
import co.maytes.standupbot.dashboard.features.standupruns.StandupFilterState
import co.maytes.standupbot.dashboard.lib.api.ApiError
import co.maytes.standupbot.shared.dto.common.PageInfoDto
import co.maytes.standupbot.shared.dto.standup.StandupDto
import co.maytes.standupbot.shared.dto.standuprun.StandupRunSummaryDto
import com.kttipay.mvi.api.MVIAction
import com.kttipay.mvi.api.MVIIntent
import com.kttipay.mvi.api.MVIState

object RunsListContract {
    sealed interface Status {
        data object Idle : Status
        data object Loading : Status
        data object LoadingMore : Status
        data object Loaded : Status
        data object Refreshing : Status
        data class Error(val error: ApiError) : Status
    }

    data class State(
        val workspaceId: String? = null,
        val status: Status = Status.Idle,
        val items: List<StandupRunSummaryDto> = emptyList(),
        val pageInfo: PageInfoDto? = null,
        val filters: StandupFilterState = StandupFilterState(),
        val standups: List<StandupDto> = emptyList(),
        val hasEntered: Boolean = false,
    ) : MVIState {
        val showsRows: Boolean
            get() = status == Status.Loaded || status == Status.LoadingMore || status == Status.Refreshing
        val isEmpty: Boolean get() = (status == Status.Loaded || status == Status.Refreshing) && items.isEmpty()
        val phase: ViewPhase
            get() = when (status) {
                Status.Idle, Status.Loading -> ViewPhase.Loading
                is Status.Error -> ViewPhase.Error
                Status.Loaded, Status.LoadingMore, Status.Refreshing -> if (isEmpty) ViewPhase.Empty else ViewPhase.Ready
            }
    }

    sealed interface Intent : MVIIntent {
        data class Load(val workspaceId: String) : Intent
        data object LoadMore : Intent
        data class SetFilters(val filters: StandupFilterState) : Intent
        data object ClearFilters : Intent
        data class OpenRun(val runId: String) : Intent
        data object GoToOnboarding : Intent
    }

    sealed interface Action : MVIAction {
        data class Navigate(val path: String) : Action
    }
}
